import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Header from "../../components/Header";
import Menu from "../../components/Menu";
import Form from "../../../../../components/shared/Form";
import Settings from "./Settings";
import { usePreferenceMutation } from "../../api/usePreferenceMutation";
import { useCompanyPreferences } from "../../hooks/usePreferences";
import { useElementHeight } from "../../../../../utils/hooks/useElementHeight";

const options: string[] = ["settings"];

function General() {
    const { ref, height } = useElementHeight();
    const [option, setOption] = useState<string>("settings");
    const scheduleSettings = useCompanyPreferences("scheduleSettings");
    const { mutate, isPending } = usePreferenceMutation("company", "scheduleSettings");

    const formDefaults = useMemo(() => ({
        skills: scheduleSettings?.skills ?? false,
        licenses: scheduleSettings?.licenses ?? false,
        certifications: scheduleSettings?.certifications ?? false,
    }), [scheduleSettings]);

    const form = useForm({
        defaultValues: formDefaults,
        values: scheduleSettings === undefined ? undefined : formDefaults,
        resetOptions: { keepDirtyValues: true },
    });

    const onFinish = (value: typeof formDefaults) => mutate({ ...scheduleSettings, ...value });

    return (
        <div className="tw-p-5 tw-h-full tw-bg-white tw-rounded-lg">
            <Form className="tw-h-full" form={form} onFinish={onFinish}>
                <div ref={ref} className="tw-flex tw-flex-col">
                    <Header name="general" isLoading={isPending} />
                    <Menu
                        options={options}
                        option={option}
                        setOption={setOption}
                    />
                </div>

                <div className="tw-px-7 tw-overflow-auto" style={{ height: `calc(100% - ${height}px - 100px)` }}>
                    <Settings />
                </div>
            </Form>
        </div>
    );
}

export default General;
